import { globalFaqs } from "@/config/site";
import { SEO, breadcrumbLd, faqLd } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTA } from "@/components/CTA";
import { FAQAccordion } from "@/components/FAQAccordion";

export default function Faq() {
  return (
    <>
      <SEO
        title="FAQs | North Ember Painting — Delta, BC Painters"
        description="Answers to common questions about painting costs, preparation, scheduling, insurance, service areas, cabinets, exteriors and working with North Ember Painting in Delta, BC."
        path="/faqs"
        jsonLd={[
          faqLd(globalFaqs),
          breadcrumbLd([{ name: "Home", path: "/" }, { name: "FAQs", path: "/faqs" }]),
        ]}
      />
      <PageHero
        eyebrow="FAQs"
        title="Honest answers to the questions we hear most"
        intro="Pricing, preparation, scheduling, insurance and what working with us actually looks like."
        image="swatchCompare"
      />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <FAQAccordion faqs={globalFaqs} idPrefix="faq-page" />
          </Reveal>
          <Reveal className="mt-10">
            <p className="text-sm leading-relaxed text-slate-500">
              Have a question we haven't covered? Call or message any time — we're happy to talk it through
              before you commit to anything.
            </p>
          </Reveal>
        </div>
      </section>
      <CTA />
    </>
  );
}
